import type { RedirectionRoute } from "./router-redirections.type";

import { matchPath } from "react-router";

export const getRedirectionPath = (
  routes: RedirectionRoute[],
  pathname: string
): string | undefined => {
  for (const route of routes) {
    const redirectPath = matchRedirectionRoute(route, pathname);
    if (redirectPath) return redirectPath;
  }

  return undefined;
};

const matchRedirectionRoute = (
  route: RedirectionRoute,
  pathname: string
): string | undefined => {
  const match = matchPath({ path: route.from, end: true }, pathname);

  if (!match) return undefined;

  return route.to.replace(
    /:(\w+)/g,
    (_, key: string) => match.params[key] ?? `:${key}`
  );
};
